import {
  GetLeadEmbedQueryVariables,
  HandleLeadMutationVariables,
  LeadQueryVariables,
  LeadsQueryVariables,
} from 'generated/graphql';
import logger from 'js-logger';

import backendClient from '../backend';

export class Lead {
  static async getEmbed(args: GetLeadEmbedQueryVariables) {
    try {
      return (await backendClient.getLeadEmbed(args)).data?.getLeadEmbed;
    } catch (e) {
      logger.error(e);
    }
  }

  public static async findMany(args: LeadsQueryVariables) {
    try {
      return (await backendClient.Leads(args)).data?.Leads;
    } catch (err) {
      logger.error(err);
    }
  }

  public static async findFirst(args: LeadQueryVariables) {
    try {
      return (await backendClient.Lead(args)).data?.Lead;
    } catch (err) {
      logger.error(err);
    }
  }

  public static async handleLead(args: HandleLeadMutationVariables) {
    try {
      return (await backendClient.handleLead(args)).data?.handleLead;
    } catch (err) {
      logger.error(err);
    }
  }
}
